import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import {ShippingPriceBookEventContainerModel} from '../../../../../../models/aggregates/erp/shipping-price-book';

@Injectable({providedIn: 'root'})
export class ShippingPriceBookEventService extends BaseApiTemplateService<ShippingPriceBookEventContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'shipping-pricebooks/events';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'shipping-pricebooks/events';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'shipping-pricebooks/events';
    this.httpClient = http;
  }
}
